import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { zustandUseOneDrugOrderStorage } from 'src/utils/cookieHelper';
import { mountStoreDevtool } from 'simple-zustand-devtools';

interface State {
  oneDrugOrder?: boolean;
  setOneDrugOrder?: (state: boolean) => void;
  backRoute?: string;
  setBackRoute?: (backRoute: string) => void;
}

const useOneDrugOrderStore = create<State>()(
  persist(
    (set) => ({
      oneDrugOrder: false,
      setOneDrugOrder: (oneDrugOrder) => set({ oneDrugOrder }),
      backRoute: null,
      setBackRoute: (backRoute) => set({ backRoute })
    }),
    {
      name: zustandUseOneDrugOrderStorage,
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export const oneDrugOrderStoreFallback: State = {
  oneDrugOrder: false,
  backRoute: null,
  setOneDrugOrder: () => null,
  setBackRoute: () => null
};

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('OneDrugOrderStore', useOneDrugOrderStore);
}

export default useOneDrugOrderStore;
